import { useContext } from 'react';
import { SidebarContext } from 'app/state/contexts/SidebarContext';
import { useTagSelection } from 'app/state/contexts/TagContext';
import { IconButton } from 'shared/ui/IconButton/IconButton';
import { usePermissions } from 'app/api/permission-queries';
import { useEditorScope } from 'app/state/contexts/EditorScopeContext';

interface SelectedCell {
  row: number;
  col: number;
  value: string;
  isNumeric: boolean;
}

interface AddTagProps {
  element: {
    uuid: string;
  };
  // Table-specific props (optional)
  selectedCells?: SelectedCell[];
  referenceDataSuperId?: string;
  onTagsCreated?: () => void;
}

export const AddTag = ({ element, selectedCells, referenceDataSuperId, onTagsCreated }: AddTagProps) => {
  const { setIsSidebarOpen, setActiveTagsTab } = useContext(SidebarContext);
  const { setDraftTag, setTableTagSelection } = useTagSelection();
  const documentId = useEditorScope()?.documentId ?? '';
  const { documentPermissions } = usePermissions(documentId);
  const isTagViewer = documentPermissions.includes('TAG_VIEWER') && !documentPermissions.includes('TAG_EDITOR') && !documentPermissions.includes('TAG_ADMIN');

  if (isTagViewer) {
    return null;
  }

  // Check if this is a table tagging scenario
  const isTableTagging = !!selectedCells?.length;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (isTableTagging) {
      // Table tagging: store selection in context for Footer to use
      if (setTableTagSelection) {
        setTableTagSelection({
          element,
          referenceDataSuperId,
          cells: selectedCells,
          onTagsCreated,
        });
      }
      // Open sidebar to tags tab (index 7) and switch to taxonomy
      setActiveTagsTab('taxonomy');
      setIsSidebarOpen(8);
    } else {
      // Text tagging: store the element ID for the Footer to use
      setDraftTag({ onId: element.uuid });
      // Open sidebar to tags tab (index 7) and switch to taxonomy
      setActiveTagsTab('taxonomy');
      setIsSidebarOpen(8);
    }
  };

  // Disable button if table tagging mode but no cells selected
  const isDisabled = isTableTagging && !selectedCells?.length;

  return <IconButton icon="tag" onMouseDown={handleClick} disabled={isDisabled} />;
};
